import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { ThemeSlotPropsMap } from "@huub-web/ui/contexts/ThemeSlotContext";

import { VerenigingEigenHuisMaskedBanner } from "./VerenigingEigenHuisMaskedBanner";

type Props = ThemeSlotPropsMap["pageHeading"];

const IMAGE_MAP: Record<string, string> = {
  advice:
    "https://assets-eu-01.kc-usercontent.com/0a476483-b2ac-0128-c5e1-a80361083e05/081c75e5-83b0-4945-be93-7c285962d808/BL2_6975jpeg.jpg?w=1000&q=90&lossless=false&auto=format&fm=jpg",
  documentsOutgoing:
    "https://assets-eu-01.kc-usercontent.com/0a476483-b2ac-0128-c5e1-a80361083e05/a6d06a5e-8b4c-4ab8-9848-e33fd350d656/BL2_4730jpeg.jpg?fm=webp&lossless=0&q=80&w=1000",
  documentsIncoming:
    "https://assets-eu-01.kc-usercontent.com/0a476483-b2ac-0128-c5e1-a80361083e05/a6d06a5e-8b4c-4ab8-9848-e33fd350d656/BL2_4730jpeg.jpg?fm=webp&lossless=0&q=80&w=1000",
  interestRates:
    "https://assets-eu-01.kc-usercontent.com/0a476483-b2ac-0128-c5e1-a80361083e05/c84f92b6-3a50-4459-807c-b4f6f623f891/ECS_1720.jpg?w=1000&q=90&lossless=false&auto=format&fm=jpg",
  maximumMortgage:
    "https://assets-eu-01.kc-usercontent.com/0a476483-b2ac-0128-c5e1-a80361083e05/cc9073e9-72ca-4f18-b05e-6d52248d0890/BL2_4870jpeg.jpg?fm=webp&lossless=0&q=80&w=1000",
  orientation:
    "https://assets-eu-01.kc-usercontent.com/0a476483-b2ac-0128-c5e1-a80361083e05/23d658ab-fd50-494e-a19f-cd8d1602d65b/BL2_5866jpeg.jpg?fm=webp&lossless=0&q=80&w=1200&h=870&fit=crop",
};

export const VerenigingEigenHuisPageHeading: FC<Props> = ({ scope }) => {
  const { t } = useTranslation();

  return (
    <VerenigingEigenHuisMaskedBanner
      title={t(`${scope}Heading.title`)}
      description={t(`${scope}Heading.description`)}
      imageSrc={IMAGE_MAP[scope] ?? ""}
    />
  );
};
